import { AppEvents } from '$scripts/events/events';
import { CriticalOutcome, Outcome } from '$scripts/outcome';
import { queryState as qs } from '$scripts/query-state';
import { socialWebDeeplinkUrl } from '$scripts/urls/list';
import { SocialProvider } from '$shared/types/social-provider';
import { getApplicationState } from '$store/application-store';
import { defaultHandleRedirect } from '$traits/handlers';
import {
  GetOutcomes,
  RemainingOutcomes,
  outcomeFunction,
} from '$traits/helpers';
import { RedirectOutcome } from '$traits/outcomes';
import { convertError } from '@sentry/shared';

interface ActionDependencies {
  getApplicationState: typeof getApplicationState;
}

function createAction({ getApplicationState }: ActionDependencies) {
  return async function action(socialProvider: SocialProvider) {
    try {
      const { events, queryState } = await getApplicationState();
      events.sendProvider(socialProvider);

      const url = socialWebDeeplinkUrl({
        ...qs.toObject(queryState),
        provider_id: socialProvider,
      })();
      return new RedirectOutcome({ url });
    } catch (e) {
      const error = convertError(e);
      return new CriticalOutcome(error);
    }
  };
}

export const outcomeAction = outcomeFunction(
  createAction({ getApplicationState })
);

export type TraitOutcome = GetOutcomes<typeof outcomeAction>;

export function handleOutcome<T extends Outcome>(
  events: AppEvents,
  outcome: T
) {
  defaultHandleRedirect(events, outcome);

  return outcome as RemainingOutcomes<T, TraitOutcome>;
}

export const trait = {
  action: outcomeAction,
  handle: handleOutcome,
};
